import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export default function Investments() {

  const token = localStorage.getItem("adminToken");

  const [investments, setInvestments] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadInvestments();
  }, []);

  async function loadInvestments() {

    try {

      const res = await fetch("/api/admin/investments", {

        headers: {
          Authorization: "Bearer " + token
        }

      });

      const data = await res.json();

      if (Array.isArray(data)) {

        setInvestments(data);

      } else {

        setInvestments(data.investments || []);

      }

    } catch (err) {

      console.log(err);

    }

    setLoading(false);

  }

  return (

    <div
      style={{
        display: "flex",
        background: "#f3f4f6",
        minHeight: "100vh"
      }}
    >

      <Sidebar />

      <div style={{ flex: 1 }}>

        <Header />

        <div style={{ padding: 25 }}>

          <h2>Investment History</h2>

          {

            loading ?

            <h3>Loading...</h3>

            :

            <table
              width="100%"
              cellPadding="10"
              style={{
                background: "#fff",
                borderCollapse: "collapse"
              }}
            >

              <thead>

                <tr
                  style={{
                    background: "#2563eb",
                    color: "#fff"
                  }}
                >

                  <th>User ID</th>

                  <th>Amount</th>

                  <th>Plan</th>

                  <th>Status</th>

                  <th>Total Profit</th>

                  <th>Profit Withdrawn</th>

                  <th>Start</th>

                  <th>End</th>

                  <th>Created</th>

                </tr>

              </thead>

              <tbody>

                {

                  investments.length === 0 ?

                  (

                    <tr>

                      <td
                        colSpan="9"
                        style={{
                          textAlign: "center",
                          padding: 20
                        }}
                      >

                        No Investment Found

                      </td>

                    </tr>

                  )

                  :

                  investments.map((item) => (

                    <tr key={item._id}>

                      <td>

                        {item.userId}

                      </td>

                      <td>

                        {Number(
                          item.amount || 0
                        ).toFixed(2)} USDT

                      </td>

                      <td>

                        {item.planDays} Days

                      </td>

                      <td>

                        <span
                          style={{
                            color:
                              item.isActive
                                ? "green"
                                : "red",
                            fontWeight: "bold"
                          }}
                        >

                          {

                            item.isActive

                              ? "Active"

                              : "Expired"

                          }

                        </span>

                      </td>

                      <td>

                        {Number(
                          item.totalProfitGenerated || 0
                        ).toFixed(6)}

                      </td>

                      <td>

                        {Number(
                          item.totalProfitWithdrawn || 0
                        ).toFixed(6)}

                      </td>

                      <td>

                        {

                          item.startTime

                            ?

                            new Date(
                              item.startTime
                            ).toLocaleString()

                            :

                            "-"

                        }

                      </td>

                      <td>

                        {

                          item.endTime

                            ?

                            new Date(
                              item.endTime
                            ).toLocaleString()

                            :

                            "-"

                        }

                      </td>

                      <td>

                        {

                          item.createdAt

                            ?

                            new Date(
                              item.createdAt
                            ).toLocaleString()

                            :

                            "-"

                        }

                      </td>

                    </tr>

                  ))

                }

              </tbody>

            </table>

          }

        </div>

      </div>

    </div>

  );

}
